export default __webpack_public_path__ + "static/becoming-tired-ef626ca871ef366020c1aeaf4344e3cb.svg";